import { useParams } from "react-router-dom";
import { pathRoutingEnabled } from "../services/urlBuilder";

export const usePlacementPath = (): ((placementId: string) => string) => {
  const { orgPath } = useParams();

  return (placementId: string) =>
    pathRoutingEnabled() ? `/${orgPath}/${placementId}` : `/${placementId}`;
};
